import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import Navbar from "../../../components/navbar/Navbar";
import styles from "./adminRegister.module.scss";
import authService from "../../../utils/services/authService";

const AdminRegister = () => {
  const [admin, setAdmin] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    role: "admin",
  });

  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();

  const onChangeHandle = (e) => {
    const value = e.target.value;

    setAdmin({ ...admin, [e.target.name]: value });
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (
      admin.name === "" ||
      admin.email === "" ||
      admin.password === "" ||
      admin.confirmPassword === ""
    ) {
      setErrorMessage("Please fill in all fields *");
      return;
    }
    if (!admin.email.includes("@")) {
      setErrorMessage("Not a valid email address *");
      return;
    }
    if (admin.password !== admin.confirmPassword) {
      setErrorMessage("Passwords does not match *");
      return;
    } else {
      setErrorMessage("");
      const data = {
        name: admin.name,
        email: admin.email,
        password: admin.password,
        role: "admin",
      };

      const response = await authService.registerFunction(data).then((res) => {
        return res;
      });
      if (response.success === true) {
        navigate("/admin/login");
      } else {
        setErrorMessage(response.message);
      }
    }
  };

  return (
    <>
      <Navbar />
      <section className={styles.adminRegWrapper}>
        <h2 className={styles.adminRegWrapper_heading}>Register new admin</h2>
        {errorMessage !== "" ? (
          <p className={styles.errorMessage}>{errorMessage}</p>
        ) : (
          ""
        )}
        <form className={styles.adminLoginForm} action="">
          <div className={styles.formGroup}>
            <input
              type="text"
              name="name"
              aria-label="Enter name"
              placeholder="Name *"
              onChange={(e) => {
                onChangeHandle(e);
              }}
            />
          </div>

          <div className={styles.formGroup}>
            <input
              id="email"
              type="text"
              name="email"
              aria-label="Enter email"
              placeholder="Email *"
              onChange={(e) => {
                onChangeHandle(e);
              }}
            />
          </div>

          <div className={styles.formGroup}>
            <input
              id="password"
              type="password"
              name="password"
              aria-label="Enter password"
              placeholder="Password *"
              onChange={(e) => {
                onChangeHandle(e);
              }}
            />
          </div>

          <div className={styles.formGroup}>
            <input
              id="confirmPassword"
              type="password"
              name="confirmPassword"
              aria-label="Confirm password"
              placeholder="Confirm password *"
              onChange={(e) => {
                onChangeHandle(e);
              }}
            />
          </div>

          <div className={styles.formGroup}>
            <button
              type="submit"
              className={styles.formBtn}
              onClick={(e) => {
                submitHandler(e);
              }}
            >
              Sign up
            </button>
          </div>
        </form>
      </section>
    </>
  );
};

export default AdminRegister;
